module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/gold-collection@2x_d895d9.jpg";